// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "电力系统基础（俄）",
        "tec": "谷彩连",
        "week": "1-7周",
        "add": "208国教"
      },
      {
        "sub": "212国教",
        "tec": "谷彩连",
        "week": "8-10,15-18周",
        "add": "208国教"
      }
    ],
    {
      "sub": "电力电子技术（俄）",
      "tec": "李鑫",
      "week": "1-10,15-18周",
      "add": "208国教"
    },
    0,
    {
      "sub": "工程伦理",
      "tec": "李震金钰",
      "week": "1-8周",
      "add": "教学楼C座214教务"
    },
    {
      "sub": "国家安全教育",
      "tec": "周彩虹",
      "week": "7-10周",
      "add": "教学楼C座308教务"
    }
  ],
  "2": [
    0,
    [
      {
        "sub": "电力系统基础（俄）",
        "tec": "谷彩连",
        "week": "1-7周",
        "add": "208国教"
      },
      {
        "sub": "208国教",
        "tec": "谷彩连",
        "week": "8-10,15-18周",
        "add": "208国教"
      }
    ],
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "张洪涛",
      "week": "1-3,5,7-10周",
      "add": "教学楼A座118电力"
    },
    0,
    0
  ],
  "3": [
    [
      {
        "sub": "电力系统基础（俄）",
        "tec": "谷彩连",
        "week": "2,4,6周",
        "add": "212国教"
      },
      {
        "sub": "212国教",
        "tec": "谷彩连",
        "week": "8,10,16周",
        "add": "212国教"
      }
    ],
    {
      "sub": "自动控制原理（俄）",
      "tec": "于宏涛",
      "week": "1-10周",
      "add": "208国教"
    },
    0,
    0,
    {
      "sub": "国家安全教育",
      "tec": "周彩虹",
      "week": "7-10周",
      "add": "教学楼C座308教务"
    }
  ],
  "4": [
    {
      "sub": "电力电子技术（俄）",
      "tec": "李鑫",
      "week": "1-10,15-18周",
      "add": "208国教"
    },
    0,
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "张洪涛",
      "week": "1-3,5,7-10周",
      "add": "教学楼C座113教务"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "自动控制原理（俄）",
      "tec": "于宏涛",
      "week": "1-10周",
      "add": "208国教"
    },
    [
      {
        "sub": "电力系统基础（俄）",
        "tec": "谷彩连",
        "week": "1-7周",
        "add": "208国教"
      },
      {
        "sub": "208国教",
        "tec": "谷彩连",
        "week": "8-10,15-18周",
        "add": "208国教"
      }
    ],
    {
      "sub": "就业创业指导",
      "tec": "孙笑雨",
      "week": "1-8周",
      "add": "教学楼C座214教务"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
